import { useEffect, useState } from 'react';

import { useFilesUploader } from '@entities/attachment/lib/hooks';
import { TAttachmentOnClient } from '@entities/attachment/model/types';
import { useFileReplace } from '@widgets/OrdersRecognition/lib/hooks/useFileReplace';
import { formatsToUpload } from '@widgets/OrdersRecognition/model/formatsToUpload';

export const useUploadOrderItems = () => {
    const [droppedFiles, setDroppedFiles] = useState<TAttachmentOnClient[]>([]);
    const [imgUrl, setImgUrl] = useState<string | null>(null);
    const { setAttachmentsWithDelay, fileReplaceLoader, clearDroppedFiles } = useFileReplace({
        droppedFiles,
        setDroppedFiles,
    });

    const { onUploadHandler } = useFilesUploader({
        attachments: droppedFiles,
        setAttachments: setAttachmentsWithDelay,
        maxAttachmentSizeInMb: 100,
        replaceUploadFormats: formatsToUpload,
        multipleUpload: false,
    });

    useEffect(() => {
        let objectUrl: string | null = null;

        const file = droppedFiles[0]?.file;
        if (file && file.type.startsWith('image/')) {
            objectUrl = URL.createObjectURL(file);
            setImgUrl(objectUrl);
        } else {
            setImgUrl(null);
        }

        return () => {
            if (objectUrl) URL.revokeObjectURL(objectUrl);
        };
    }, [droppedFiles]);

    return {
        imgUrl,
        fileReplaceLoader,
        droppedFiles,
        onUploadHandler,
        clearDroppedFiles,
    };
};
